import HomeServicesAlert from "components/home-services/home-services-alert";
import CancellationPaymentNotice from "components/shared/cancellation-payment-notice";
import {
  useShowCancellationPaymentNotice,
  useShowCoverageNotification,
  useShowHomeServicesAlert,
} from "components/shared/notifications/hooks";
import CoverageNotification from "pages/overview/extended-coverages/coverage-notification";

import { ScheduledPaymentNotification } from "../scheduled-payment-notification";

export type NotificationName =
  | "CancellationPayment"
  | "Coverage"
  | "HomeServices"
  | "ScheduledPayment";

type Props = {
  availableNotifications: NotificationName[];
};

export const Notifications = ({ availableNotifications }: Props) => {
  const showScheduledPaymentNotifications =
    availableNotifications.includes("ScheduledPayment");

  const showHomeServiceAlert = useShowHomeServicesAlert(availableNotifications);
  const showCancellationPaymentNotice = useShowCancellationPaymentNotice(
    availableNotifications
  );
  const showCoverageNotification = useShowCoverageNotification(
    availableNotifications
  );

  return (
    <>
      {showHomeServiceAlert && <HomeServicesAlert />}
      {showCancellationPaymentNotice && <CancellationPaymentNotice />}
      {showScheduledPaymentNotifications && <ScheduledPaymentNotification />}
      {showCoverageNotification && <CoverageNotification />}
    </>
  );
};
